import { NormalizedStore } from '@store/entity/entity.types';
import { yourJourneySelectors } from '@store/yourJourney/selectors';
import moment, { Moment } from 'moment';
import { connect } from 'react-redux';
import { formValueSelector, reduxForm } from 'redux-form';
import { SingleValidationError } from 'shared-types';
import { GuestFormData } from '../SpaPackageModal.types';
import { SPA_PACKAGE_FORM_NAME, spaPackageFormConfig } from '../shared';
import {
  SpaPackageAvailabilityCombinedProps,
  SpaPackageAvailability as SpaPackageAvailabilityComponent,
} from './SpaPackageAvailability';

export const SpaPackageAvailabilityForm = reduxForm<
  SpaPackageAvailabilityCombinedProps,
  any,
  string | SingleValidationError[]
>({
  ...spaPackageFormConfig,
})(SpaPackageAvailabilityComponent);

export interface StateProps {
  arrivalTime: { startTime: string; endTime: string };
  initialValues?: { date: string };
  selectedDate: Moment;
  guests?: GuestFormData[];
}

const mapStateToProps = (state: NormalizedStore): StateProps => ({
  guests: formValueSelector(SPA_PACKAGE_FORM_NAME)(state, 'guests'),
  selectedDate: moment(
    formValueSelector(SPA_PACKAGE_FORM_NAME)(state, 'date') ||
      yourJourneySelectors.getParsedJourneyParams(state).spaDate
  ),
  arrivalTime: formValueSelector(SPA_PACKAGE_FORM_NAME)(state, 'arrivalTime'),
  initialValues: {
    date: moment(yourJourneySelectors.getParsedJourneyParams(state).spaDate).format('YYYY-MM-DD'),
  },
});

export const SpaPackageAvailabilityConnected: any = connect(mapStateToProps)(
  SpaPackageAvailabilityForm
);
